module.exports = __webpack_public_path__ + "e3993c999a489f4f03d9b7a13fbc319d.svg";